module.exports = __webpack_public_path__ + "img/b2b-logo.0a2f72e9.png";